<app-complex-modal-template
    [isConfirmationMode]="false"
    [title]="title() | transloco">
    <ng-container>
        @if (errorMessage()) {
            <p class="text-error">
                {{ errorMessage() | transloco }}
            </p>
        } @else {
            <p>
                {{ message() | transloco }}
            </p>
        }
        <app-progress-bar
            [hasError]="!!errorMessage()"
            [itemsLoaded]="updatedEntitiesCount()"
            [total]="entitiesToUpdateCount()" />
    </ng-container>
</app-complex-modal-template>
